import Api from '@/services/Api';
import MetodosGlobais from '@/utils/MetodosGlobais';

const RECURSO = '/educacao';

export default {
    buscarRedeEnsino,
    buscarFilaCreche,
    buscarFilaCrecheRegionalMensal,
    buscarMatriculas,
    buscarTMACreche,
    buscarTMACrecheDiario,
    buscarTMACrecheMensal,
    buscarTMACrecheAnual,
    buscarINSEDetalhado,
    buscarINSEConsolidado,
};

function buscarRedeEnsino ({ agrupamento }) {
    let params = { 'agrupamento': agrupamento };
    return Api.get(`${RECURSO}/instituicoesDeEnsino${MetodosGlobais.createEncodeQuery(params)}`);
};
function buscarMatriculas ({ intervalo, agrupamento }) {
    let params = { 'intervalo': intervalo, 'agrupamento': agrupamento };
    return Api.get(`${RECURSO}/matriculas${MetodosGlobais.createEncodeQuery(params)}`);
};
function buscarFilaCreche ({ intervalo }) {
    let params = { 'intervalo': intervalo };
    return Api.get(`${RECURSO}/filasDasCreches${MetodosGlobais.createEncodeQuery(params)}`);
};
function buscarFilaCrecheRegionalMensal ({ intervalo }) {
    let params = { 'intervalo': intervalo };
    return Api.get(`${RECURSO}/filasDasCrechesMensal${MetodosGlobais.createEncodeQuery(params)}`);
};
function buscarTMACreche ({ intervalo, regionalidade }) {
    let params = { 'intervalo': intervalo , 'regionalidade': regionalidade};
    return Api.get(`${RECURSO}/TMACreche${MetodosGlobais.createEncodeQuery(params)}`);
};
function buscarTMACrecheDiario ({ inicio, fim, regionalidade }) {
    let params = { 'inicio': inicio, 'fim': fim , 'regionalidade': regionalidade};
    return Api.get(`${RECURSO}/TMACrecheDiario${MetodosGlobais.createEncodeQuery(params)}`);
};
function buscarTMACrecheMensal ({ inicio, fim, regionalidade }) {
    let params = { 'inicio': inicio, 'fim': fim , 'regionalidade': regionalidade};
    return Api.get(`${RECURSO}/TMACrecheMensal${MetodosGlobais.createEncodeQuery(params)}`);
};
function buscarTMACrecheAnual ({ inicio, fim, regionalidade }) {
    let params = { 'inicio': inicio, 'fim': fim , 'regionalidade': regionalidade};
    return Api.get(`${RECURSO}/TMACrecheAnual${MetodosGlobais.createEncodeQuery(params)}`);
};

function buscarINSEDetalhado () {
    return Api.get(`${RECURSO}/indicadorSocioeconomicoDetalhado`);
};

function buscarINSEConsolidado ({agrupamento}) {
    let params = {'agrupamento': agrupamento};
    return Api.get(`${RECURSO}/indicadorSocioeconomicoConsolidado${MetodosGlobais.createEncodeQuery(params)}`);
};